import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button, Alert } from "~/components-shared";
import { StatusStateEnum } from "~/types/enums";
import { useDispatch, useSelector } from "react-redux";
import onboardingActionCreators from "~/store/onboarding/actions";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import TopicRetroForm from "~/forms/TopicRetroForm";
import topicRetroSchema from "~/forms/TopicRetroForm/topicRetroSchema";
import topicSelectors from "~/store/topics/selectors";
import topicActionCreators from "~/store/topics/actions";
import toastsActionCreators from "~/store/toasts/actions";
import moment from "moment";
const Actions = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: right;
  margin-top: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.step * 5;
}}px;
  margin-bottom: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing.step * 2;
}}px;
`;
const OnboardingTopicsRetro = _ref3 => {
  let {
    topic,
    onSuccess,
    onBack,
    ...rest
  } = _ref3;
  const {
    t
  } = useTranslation();
  const status = useSelector(topicSelectors.getRetroStatus);
  const error = useSelector(topicSelectors.getRetroError);
  const dispatch = useDispatch();
  const defaultValues = useMemo(() => ({
    sources: topic?.sources || [],
    dateFrom: undefined,
    dateTo: undefined,
    directMapping: false
  }), [topic]);
  const {
    handleSubmit,
    control,
    setValue,
    watch
  } = useForm({
    resolver: yupResolver(topicRetroSchema),
    defaultValues
  });
  const onSubmit = handleSubmit(data => {
    if (topic?.id) {
      data.dateFrom = moment(data.dateFrom).startOf("day").toISOString();
      data.dateTo = moment(data.dateTo).endOf("day").toISOString();
      dispatch(topicActionCreators.runRetroStarted(topic.id, data, _ref4 => {
        let {
          data: response
        } = _ref4;
        if (response) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("TopicRunRetroModal.retroInProgress"),
            timeout: 10000
          }));
          dispatch(onboardingActionCreators.companyTopicsSubmitStarted());
        }
      }));
    }
  });
  const onSkip = () => {
    dispatch(onboardingActionCreators.companyTopicsSkipStarted());
  };
  return /*#__PURE__*/React.createElement("form", _extends({
    onSubmit: onSubmit
  }, rest), error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(TopicRetroForm, {
    topic: topic,
    control: control,
    setValue: setValue,
    watch: watch
  }), /*#__PURE__*/React.createElement(Actions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onBack,
    color: "transparent",
    s: {
      px: 8,
      mr: 3
    },
    disabled: status === StatusStateEnum.LOADING,
    rounded: true
  }, t("common.actions.back")), /*#__PURE__*/React.createElement(Button, {
    onClick: onSkip,
    color: "grey",
    s: {
      px: 8,
      mr: 3
    },
    disabled: status === StatusStateEnum.LOADING,
    rounded: true
  }, t("common.actions.skip")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    loading: status === StatusStateEnum.LOADING,
    s: {
      ml: 2
    },
    fullWidth: true,
    rounded: true,
    shadow: true
  }, t("OnboardingTopicsRetro.finish"))));
};
export default OnboardingTopicsRetro;